import type { MessagingAccountDTO } from '@arhs-fleetback/types/entities/messaging-accounts';
import { combineReducers } from 'redux';

import type { Action } from 'modules/global/generic.types';
import loading from 'modules/global/reducers/generic.loading';
import * as types from 'modules/messagingAccounts/actionTypes';
import { MODAL_SOURCE } from 'modules/messagingAccounts/constants';
import type { FetchMessagingAccountSuccessAction, OpenMessagingAccountModalAction } from 'modules/messagingAccounts/types';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const MODAL_CLOSE_ACTIONS = [
  LOCATION_CHANGE,
  types.CLOSE_MODAL,
  types.CREATE_MESSAGING_ACCOUNT_SUCCESS,
  types.UPDATE_MESSAGING_ACCOUNT_SUCCESS,
];

const closeMatcher = ({ type }: Action) => MODAL_CLOSE_ACTIONS.includes(type);

const modalSourceMatcher = ({ meta }: Action) => meta?.source === MODAL_SOURCE;

export default combineReducers({
  open: createReducer(
    false,
    { [types.OPEN_MODAL]: () => true },
    [{ matcher: closeMatcher, reducer: () => false }]
  ),
  entityId: createReducer<string | null>(
    null,
    { [types.OPEN_MODAL]: (_, { payload }: OpenMessagingAccountModalAction) => payload ?? null },
    [{ matcher: closeMatcher, reducer: () => null }]
  ),
  account: createReducer<MessagingAccountDTO | null>(
    null,
    {
      [types.OPEN_MODAL]: () => null,
      [types.FETCH_MESSAGING_ACCOUNT_SUCCESS]: (_, { payload }: FetchMessagingAccountSuccessAction) => payload,
    },
    [{ matcher: closeMatcher, reducer: () => null }]
  ),
  fetching: loading(types.FETCH_MESSAGING_ACCOUNT, { global: { matcher: modalSourceMatcher } }),
  saving: combineReducers({
    creating: loading(types.CREATE_MESSAGING_ACCOUNT),
    updating: loading(types.UPDATE_MESSAGING_ACCOUNT),
  }),
});
